import { render, staticRenderFns } from "./Recovery.vue?vue&type=template&id=5b63120a&scoped=true"
import script from "./Recovery.vue?vue&type=script&lang=js"
export * from "./Recovery.vue?vue&type=script&lang=js"
import style0 from "./Recovery.vue?vue&type=style&index=0&id=5b63120a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b63120a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b63120a')) {
      api.createRecord('5b63120a', component.options)
    } else {
      api.reload('5b63120a', component.options)
    }
    module.hot.accept("./Recovery.vue?vue&type=template&id=5b63120a&scoped=true", function () {
      api.rerender('5b63120a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/clientManage/customerPointsManagement/dialogs/Recovery.vue"
export default component.exports